import { AnimalSpecies } from 'app/agriculture/queries/herds/types/AnimalSpecies';
import { HerdType } from 'app/agriculture/queries/herds/types/HerdType';
import { HerdCreateForm } from './HerdCreateForm';
import './HerdCreate.scss';

export interface HerdCreateFields {
    name: string;
    animalSpecies: AnimalSpecies;
    herdType: HerdType;
    snapshot: {
        paddockId: string | number | null;
        totalAnimals: number;
        timestamp?: Date;
    };
}

export function HerdCreate() {
    return <HerdCreateForm />;
}
